import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LEAD_TIME_FILTER_OPTIONS } from "../../../shared/constants/pricelist.constants";

export interface ShippingDateFilters {
    [key: string]: boolean;
}

@Component({
    selector: "vsf-shipping-date-filter",
    templateUrl: "./shipping-date-filter.component.html",
})
export class ShippingDateFilterComponent implements OnInit {
    @Input() filtersExpanded = false;
    @Input() loading = false;
    @Output() filterChange = new EventEmitter<string[]>();

    readonly filterOptions = LEAD_TIME_FILTER_OPTIONS;

    selectedShippingDate: string | null = null;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            if (params["shippingDate"]) {
                const ranges = params["shippingDate"].split(",");
                this.selectedShippingDate = ranges[0] || null;
            } else {
                this.selectedShippingDate = null;
            }
        });
    }

    onShippingDateFilterChange(): void {
        const selectedRanges: string[] = this.selectedShippingDate ? [this.selectedShippingDate] : [];
        this.filterChange.emit(selectedRanges);
    }

    clearFilters(): void {
        this.selectedShippingDate = null;
        this.filterChange.emit([]);
    }
}
